let serverAddress = ""
if (process.env.NODE_ENV === "development") {
  serverAddress = "http://127.0.0.1:8080"
}

export const config = {
  serverAddress,
}
